/** Redação defensiva na UI (registros antigos podem ter sido gravados sem mascarar). */

const SENSITIVE_KEYS = new Set([
  "authorization",
  "api_key",
  "apikey",
  "apikeygupshup",
  "apisecret",
  "api_secret",
  "password",
  "senha",
  "senhatotalbus",
  "senhapraxxio",
  "token",
  "accesstoken",
  "refresh_token",
  "secret",
  "webhook_secret",
  "x-api-key",
  "proxy-authorization",
  "cookie",
  "set-cookie",
]);

function isSensitiveHeaderName(name) {
  const n = String(name || "").trim().toLowerCase();
  if (!n) return false;
  if (SENSITIVE_KEYS.has(n)) return true;
  return (
    n.includes("authorization") ||
    n.includes("apikey") ||
    n.includes("api-key") ||
    n.includes("token") ||
    n.includes("secret") ||
    n.includes("password") ||
    n.includes("senha")
  );
}

export function redactSecretsInString(value) {
  if (value == null || typeof value !== "string") return value;
  if (value.includes("[REDACTED]")) return value;
  let out = value;
  out = out.replace(/(\bapi[_-]?key\b\s*[:=]\s*["']?)([^"'\s&},]+)/gi, "$1[REDACTED]");
  out = out.replace(/(\bapikey\s*:\s*)([^\s"',]+)/gi, "$1[REDACTED]");
  out = out.replace(/(\bAuthorization\s*:\s*)([^\s"',]+)/gi, "$1[REDACTED]");
  out = out.replace(/\bBearer\s+[A-Za-z0-9\-._~+/]+=*\b/gi, "Bearer [REDACTED]");
  out = out.replace(/\bBasic\s+[A-Za-z0-9+/=]+\b/gi, "Basic [REDACTED]");
  out = out.replace(
    /([?&](?:api[_-]?key|access[_-]?token|token|secret|password)=)([^&\s"']+)/gi,
    "$1[REDACTED]"
  );
  return out;
}

function redactHttpHeaderLine(line) {
  if (line == null) return line;
  const s = String(line);
  const idx = s.indexOf(":");
  if (idx <= 0) return redactSecretsInString(s);
  const name = s.slice(0, idx).trim();
  if (isSensitiveHeaderName(name)) return `${name}: [REDACTED]`;
  return s;
}

function sanitizeHttpHeaders(headers) {
  if (headers == null) return {};
  if (Array.isArray(headers)) {
    return headers.map((entry) => {
      if (typeof entry === "string") return redactHttpHeaderLine(entry);
      if (Array.isArray(entry) && entry.length >= 1) {
        const key = String(entry[0]);
        if (isSensitiveHeaderName(key)) return [key, "[REDACTED]"];
        return entry;
      }
      if (entry && typeof entry === "object") return redactAuditValue(entry);
      return entry;
    });
  }
  if (typeof headers === "object") return redactAuditValue(headers);
  if (typeof headers === "string") return redactHttpHeaderLine(headers);
  return headers;
}

function redactAuditValue(value, depth = 0) {
  if (depth > 14) return "[MAX_DEPTH]";
  if (value == null) return value;
  if (typeof value === "string") return redactSecretsInString(value);
  if (Array.isArray(value)) {
    const isHeaderLines = value.every((x) => typeof x === "string" && x.includes(":"));
    if (isHeaderLines) return value.map(redactHttpHeaderLine);
    return value.map((x) => redactAuditValue(x, depth + 1));
  }
  if (typeof value === "object") {
    const out = {};
    for (const [k, v] of Object.entries(value)) {
      const lk = String(k).toLowerCase();
      if (SENSITIVE_KEYS.has(lk) || isSensitiveHeaderName(lk)) {
        out[k] = "[REDACTED]";
      } else {
        out[k] = redactAuditValue(v, depth + 1);
      }
    }
    return out;
  }
  return value;
}

/** Aplica redação antes de exibir ou copiar audit na UI. */
export function sanitizePartnerApiAuditForDisplay(audit) {
  if (!audit || typeof audit !== "object") return audit;
  const copy = JSON.parse(JSON.stringify(audit));
  if (copy.request) {
    copy.request = redactAuditValue(copy.request);
    if (copy.request.headers != null) {
      copy.request.headers = sanitizeHttpHeaders(copy.request.headers);
    }
  }
  if (copy.response) {
    copy.response = redactAuditValue(copy.response);
    if (copy.response.headers != null) {
      copy.response.headers = sanitizeHttpHeaders(copy.response.headers);
    }
  }
  return copy;
}
